<template>
  <div>
    <p class="tw:font-bold tw:mb-3">{{ label }}</p>
    <ul class="tw:flex tw:flex-wrap">
      <li
        v-for="option in options"
        :key="option.id"
        :class="type === 'flyout' ? 'flyout-item' : 'item'"
        class="tw:flex tw:items-center tw:text-sm"
      >
        <input
          type="radio"
          :name="name"
          :value="option.id"
          :id="`${name}_${option.id}`"
          :checked="isSelected(option)"
          @change="onSelect(option)"
          class="tw:cursor-pointer"
        />
        <label
          :for="`${name}_${option.id}`"
          class="tw:cursor-pointer tw:py-2 tw:m-0 tw:pl-3 tw:grow tw:flex tw:items-center tw:flex-wrap"
          >{{ $t(option.label) }}</label
        >
      </li>
    </ul>
    <div v-if="value.id === 'custom-range'" class="tw:mt-4">
      <MonthRangePicker
        :from="startDate"
        :to="endDate"
        :type="type"
        @setCustomFromDate="onStartDateSelect"
        @setCustomToDate="onEndDateSelect"
      />
    </div>
  </div>
</template>
<script setup>
import MonthRangePicker from '@/components/billing/invoices/filters/MonthRangePicker.vue'

const emit = defineEmits(['onSelect', 'onStartDateSelect', 'onEndDateSelect'])
const onSelect = value => emit('onSelect', value)
const onStartDateSelect = newStartDate => emit('onStartDateSelect', newStartDate)
const onEndDateSelect = newEndDate => emit('onEndDateSelect', newEndDate)

const props = defineProps({
  name: String,
  label: String,
  options: Array,
  value: Object,
  type: String,
  startDate: String,
  endDate: String,
})

const isSelected = item => props.value && props.value.id === item.id
</script>
<style scoped>
.item {
  flex-basis: 100%;
  box-sizing: border-box;
}
.flyout-item {
  flex-basis: 50%;
}
</style>
